import PaymentInstructionLayout from "../layouts/PaymentInstructionLayout";
import { useState } from "react";
import { X, Copy, Check, ChevronDown, ChevronUp } from "lucide-react";
// import CountDownTimer from "./CountDownTimer";
// import formatCurrency from "../../utils/numberFormatter";
import METHOD_LOGO from "./MethodLogos";

const METHOD_LOGOS = METHOD_LOGO;

export default function PaymentInstructionOffline({
  amount,
  orderId,
  merchantName,
  expired_at,
  selected_method,
  onCheckStatus,
  paymentCode,
  storeName,
  storeCode,
}) {
  const [copied, setCopied] = useState(false);
  const [activeSection, setActiveSection] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const instructions = [
    `Go to the nearest ${storeName} and show your payment code/barcode to the cashier.`,
    "The cashier will confirm your transaction details.",
    "Confirm your payment with the cashier.",
    "Once your transaction is successful, you'll receive a confirmation email.",
    `Please keep your ${storeName} receipt in case you need further assistance.`,
  ];

  return (
    <PaymentInstructionLayout
      amount={amount}
      orderId={orderId}
      merchantName={merchantName}
      expiredAt={expired_at}
      selectedMethod={selected_method}
      onCheckStatus={onCheckStatus}
      paymentCredential={
        <div className="space-y-4 mt-4">
          <div className="flex items-center gap-2">
            <h3 className="text-xl font-bold">{storeName}</h3>
            <img 
              src={METHOD_LOGOS[storeCode] || "/placeholder.svg"} 
              alt={`${storeName} Logo`} 
              className="h-8 w-8 object-contain" 
            />
          </div>
          <p className="text-gray-600">Show this code to the cashier to complete your payment.</p>
          <div className="space-y-2">
            <label className="block text-gray-700 font-medium">Payment Code</label>
            <div className="flex items-center gap-2 p-4 bg-gray-50 border border-gray-200 rounded-lg font-mono text-lg">
              <span className="flex-1">{paymentCode}</span>
              <button onClick={handleCopy} className="text-blue-600 hover:text-blue-700 flex items-center">
                {copied ? <Check size={18} /> : <Copy size={18} />}
              </button>
            </div>
          </div>
        </div>
      }
      howToPay={
        <div className="space-y-4 mt-6">
          <h3 className="text-xl font-bold">How to Pay</h3>
          <div className="space-y-2">
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                className="w-full p-4 flex items-center justify-between bg-gray-50 hover:bg-gray-100"
                onClick={() => setActiveSection(!activeSection)}
              >
                <span className="font-medium">Step-by-step Instructions</span>
                {activeSection ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </button>
              {activeSection && (
                <div className="p-4 bg-white border-t border-gray-200">
                  <ol className="list-inside space-y-2 text-gray-600">
                    {instructions.map((step, index) => (
                      <li key={index}>{index + 1}. {step}</li>
                    ))}
                  </ol>
                </div>
              )}
            </div>
          </div>
        </div>
      }
    />
  );
}
